/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RedemptionLimitFrequencyPeriod } from './RedemptionLimitFrequencyPeriod';
import {
    RedemptionLimitFrequencyPeriodFromJSON,
    RedemptionLimitFrequencyPeriodFromJSONTyped,
    RedemptionLimitFrequencyPeriodToJSON,
} from './RedemptionLimitFrequencyPeriod';

/**
 * Calendar-based frequency limit for reward redemption
 * Limits how many rewards a player can earn per time period
 * @export
 * @interface RedemptionLimitFrequency
 */
export interface RedemptionLimitFrequency {
    /**
     * 
     * @type {number}
     * @memberof RedemptionLimitFrequency
     */
    limit: number;
    /**
     * The calendar period for the limit
     * @type {RedemptionLimitFrequencyPeriod}
     * @memberof RedemptionLimitFrequency
     */
    frequency: RedemptionLimitFrequencyPeriod;
}



/**
 * Check if a given object implements the RedemptionLimitFrequency interface.
 */
export function instanceOfRedemptionLimitFrequency(value: object): value is RedemptionLimitFrequency {
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('frequency' in value) || value['frequency'] === undefined) return false;
    return true;
}

export function RedemptionLimitFrequencyFromJSON(json: any): RedemptionLimitFrequency {
    return RedemptionLimitFrequencyFromJSONTyped(json, false);
}

export function RedemptionLimitFrequencyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RedemptionLimitFrequency {
    if (json == null) {
        return json;
    }
    return {
        
        'limit': json['limit'],
        'frequency': RedemptionLimitFrequencyPeriodFromJSON(json['frequency']),
    };
}

export function RedemptionLimitFrequencyToJSON(value?: RedemptionLimitFrequency | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'limit': value['limit'],
        'frequency': RedemptionLimitFrequencyPeriodToJSON(value['frequency']),
    };
}

